import type { Authorization } from './types'

export const isOperationPermitted = (authorization: Authorization, operationId: string): boolean => {
  const userPermissions = authorization.permissions || []
  const operationPermissions = authorization.permissionsByOperationId[operationId.toLowerCase()]
  if (!operationPermissions) return false
  // Operations that declare no permissions are open to any authenticated user,
  // matching the API's authorization logic
  if (operationPermissions.length === 0) return true
  return operationPermissions.some(requiredPermission => userPermissions.includes(requiredPermission))
}

type Action = {
  operationId?: string;
};

type Actions = {
  [key: string]: Action;
};

export const onlyPermissibleActions = (authorization: Authorization, actionsObject: Actions) => {
  let permissibleActions: Record<string, any> = {}
  Object.keys(actionsObject).forEach((actionKey: string) => {
    const action = actionsObject[actionKey]
    const operationId = action.operationId
    if (!operationId || isOperationPermitted(authorization, operationId)) {
      permissibleActions[actionKey] = action
    }
  })
  return permissibleActions
}

export const hasPermission = (
// @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'Authorization': permissions, permissionsByOperationId
  {
// @ts-expect-error - TS2339 - Property 'permissions' does not exist on type 'Authorization | null'.
    permissions: userPermissions,
  }: Authorization | null | undefined = {},
  search: string,
): boolean => (userPermissions.includes(search))
